import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormHelperService } from '../../../helpers/form-helper.service';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';
import { HOME_PHONE_NUMBER_REGEX, MOBILE_PHONE_NUMBER_REGEX } from '@classifieds-sell/shared';

@Component({
    selector: 'property-rental-details-section',
    templateUrl: './property-rental-details-section.component.html',
    styleUrls: ['./property-rental-details-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertyRentalDetailsSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    @ViewChild('propertyRentalDetailsSectionForm')
    propertyRentalDetailsSectionForm: NgForm;

    homePhoneNumberRegex: string = HOME_PHONE_NUMBER_REGEX;
    mobilePhoneNumberRegex: string = MOBILE_PHONE_NUMBER_REGEX;

    constructor(
        public draftFacade: DraftFacade,
        private changeDetectorRef: ChangeDetectorRef,
        private formHelperService: FormHelperService
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        this.formHelperService.validate(this.propertyRentalDetailsSectionForm);
        return this.propertyRentalDetailsSectionForm.form.valid;
    }

    dirty(): boolean {
        return this.propertyRentalDetailsSectionForm.form.dirty;
    }

    onIsPropertyAgentChange(value: boolean) {
        if (!value) {
            this.draftData.propertyInformation.name = null;
            this.draftData.propertyInformation.agency = null;
        }
        this.publish();
    }
}
